module.exports = __webpack_public_path__ + "static/img/medical.8333d60f.png";